import {
  useMemo,
} from 'react';
import type {
  RefAttributes,
  InputHTMLAttributes,
} from 'react';

import styles from './Slider.module.css';

const THUMB_WIDTH = 2.5;

type SliderProps = RefAttributes<HTMLInputElement> &
                   InputHTMLAttributes<HTMLInputElement>;

const Slider = (props: SliderProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    ref,
    min,
    max,
    value,
  } = props;

  // ##########################################################################
  // MEMOIZATION
  // ##########################################################################

  const progressValue = useMemo(() => (
    (Number(value) - Number(min)) / (Number(max) - Number(min))
  ), [min, max, value]);

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const progressStyle = useMemo(() => {
    const progressTranslate = (progressValue - 1) * 100;
    let thumbOffset = (0.5 - progressValue) * THUMB_WIDTH;
    if (progressValue === 1) thumbOffset = 0;

    return {
      transform: `translateX(calc(${progressTranslate}% + ${thumbOffset}rem))`,
    };
  }, [progressValue]);

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={styles.slider}>
      <input
        {...props}
        ref={ref}
        type="range"
        className={styles.input}
      />

      <div
        style={progressStyle}
        className={styles.progress}
      />
    </div>
  );
};

export default Slider;
